import {
  ItemStockInfo,
  useItemStock,
} from "@coworker/apprestructured/src/shared/hooks/item/useItemStock";
import { ItemStockStatus } from "./ItemStockStatus";

interface ItemStockProps {
  itemNo: string;
  itemType: string;
  stockInfo?: ItemStockInfo;
  disableItemStockQuery?: boolean;
}

export const ItemStock = ({
  itemNo,
  itemType,
  stockInfo,
  disableItemStockQuery,
}: ItemStockProps) => {
  const {
    data: itemStockInfo,
    isLoading: isLoadingItemStockInfo,
    isError,
  } = useItemStock(itemType, itemNo, {
    enabled: !stockInfo && !disableItemStockQuery,
  });

  const stockData = stockInfo || itemStockInfo;

  return (
    <ItemStockStatus
      loading={isLoadingItemStockInfo}
      isError={isError}
      data={stockData}
    />
  );
};
